import { useQuery } from "@tanstack/react-query";
import { apiClient } from "../../../zodios/client";

type Params = Parameters<typeof apiClient.getPricingPlan>[0]["params"];

export const usePricingPlan = (params: Params, options?: { enabled?: boolean; refetchOnMount?: boolean }) => {
  return useQuery({
    queryKey: [{ entity: "pricing_plans", type: "item", params }],
    queryFn: async () =>
      await apiClient.getPricingPlan({
        params,
      }),
    ...options,
  });
};
